import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a6576c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "row departmentName" }
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = { class: "other" }
const _hoisted_8 = { style: {"flex":"1"} }
const _hoisted_9 = { style: {"font-size":"16px","padding-bottom":"0.1rem","display":"inline-block"} }
const _hoisted_10 = { style: {"display":"flex","font-size":"16px"} }
const _hoisted_11 = {
  key: 0,
  style: {"padding-right":"0.2rem"}
}
const _hoisted_12 = { key: 1 }

import { ref, reactive, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  CellGroup,
  Cell,
  Overlay,
  Loading,
  showFailToast,
  Tabs,
  Tab,
  Empty,
} from "vant";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";
import { numToMoney } from "@/utils";

import request from "@/provide/fetch";

export default /*#__PURE__*/_defineComponent({
  __name: 'schedulingTableCY',
  setup(__props) {

const route = useRoute();
const tabList = ["进行中", "排期中", "已完成", "暂无"];
const visible = ref(false);
const pageData = ref<any>({
  tabList: [],
});
const schedulingTable = computed(() => {
  return (
    pageData.value?.tabList.filter(
      (item: { name: any }) => item.name === tabList[activeItem.value]
    )[0] || []
  );
});
const activeItem = ref<any>(0);
const getPageData = async () => {
  const res = await request({
    url: `/api/wx/call/get-tech-task-report`,
    method: "GET",
    params: {
      "report-id": route?.params.id,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = JSON.parse(res.data.reportContent);
    visible.value = true;
  } else {
    showFailToast(res.data);
  }
};
getPageData();
const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(pageData.value.reportTime), 1)
      ]),
      _createVNode(_unref(Tabs), {
        active: activeItem.value,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((activeItem).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabList, (item) => {
            return _createVNode(_unref(Tab), {
              key: item,
              title: item
            }, null, 8, ["title"])
          }), 64))
        ]),
        _: 1
      }, 8, ["active"]),
      (!_unref(schedulingTable)?.departmentGroupList)
        ? (_openBlock(), _createBlock(_unref(Empty), {
            key: 0,
            description: "暂无数据",
            "image-size": "100"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schedulingTable)?.departmentGroupList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle({
            marginTop: '0.4rem',
          }),
                key: index,
                class: "mark"
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.departmentName), 1),
                (activeItem.value === 3)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无需求",
                      "image-size": "100"
                    }))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.itemList, (dItem, dIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: dIndex,
                        class: "itemList mark"
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(dIndex + 1), 1),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(dItem.name), 1),
                            _createElementVNode("div", _hoisted_10, [
                              (dItem.startTime)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "开始时间: " + _toDisplayString(dItem.startTime), 1))
                                : _createCommentVNode("", true),
                              (dItem.endTime)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "结束时间: " + _toDisplayString(dItem.endTime), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
              ], 4))
            }), 128))
          ]))
    ])
  ]))
}
}

})